module.exports = __webpack_public_path__ + "img/jak-dolaczyc-baner.f65417eb.png";